import { stylesheet } from 'typestyle';

export const ButtonZoneImageStyle = stylesheet({
  tabButtonZoneImageEnabledContainer: {
    position: 'relative',
    display: 'flex',
    width: 'inherit',
    height: 'inherit',
    justifyContent: 'center',
    alignItems: 'center',
  },

  tabButtonZoneImageDisabled: {
    filter: 'url("#grayscale")',
  },

  tabButtonZoneImageHover: {
    position: 'absolute',
  },
});
